import React, { Suspense, ExoticComponent } from "react";

const Loadable = (Component: ExoticComponent) => (props: JSX.IntrinsicAttributes) => (
  <Suspense fallback={<></>}>
    <Component {...props} />
  </Suspense>
);

export default Loadable;
